import { commonColor } from '/@/utils/color'
import { NightLightsStateEnum, DistanceLimitStatus, ObstacleAvoidance } from './device-setting'
import { AlarmModeEnum, BatteryStoreModeEnum, DroneBatteryStateEnum, FourGLinkStateEnum, SdrLinkStateEnum, LinkWorkModeEnum } from './airport-tsa'
import { CameraMode } from '/@/types/live-stream'
import dock from '/@/assets/icons/dock/dock_1.jpg'
import dock2 from '/@/assets/icons/dock/dock_2.png'
import dock3 from '/@/assets/icons/dock/dock_3.png'

import drone from '/@/assets/icons/drone/m30.png'
import drone2 from '/@/assets/icons/drone/m3t.png'
import drone3 from '/@/assets/icons/drone/m4t.png'
import { DEVICE_TYPE, WaylineActionType } from './wayline'

export interface DeviceValue {
  key: string; // 'domain-type-subtype'
  domain: string; // 表示一个领域，作为一个命名空间，暂时分 飞机类-0, 负载类-1, RC类-2, 机场类-3 4种
  type: number; // 设备类型枚举
  sub_type: number; // 设备类型枚举 负载一般表示镜头
}

// domain
export enum DOMAIN {
  DRONE = '0', // 飞行器
  PAYLOAD = '1', // 负载
  RC = '2', // 遥控
  DOCK = '3', // 机场
}

// DJI飞机类型
export enum DRONE_TYPE {
  M30 = 67,
  M300 = 60,
  Mavic3EnterpriseAdvanced = 77,
  M350 = 89,
  M3D = 91,
  M4D = 100,
  Mavic4EnterpriseAdvanced = 99,
}

export const NONE_OPTICAL_ZOOM_OF_AIRCRAFT = {
  [DRONE_TYPE.M30]: [5, 10, 20],
  [DRONE_TYPE.Mavic3EnterpriseAdvanced]: [1, 7],
  [DRONE_TYPE.M3D]: [1, 7],
  [DRONE_TYPE.Mavic4EnterpriseAdvanced]: [1, 3, 7],
  [DRONE_TYPE.M4D]: [1, 3, 7]
}
export const ZOOM_RULE_POINT = {
  [DRONE_TYPE.M30]: [{
    zoomNum: 2,
    zoom: '2x',
    bottom: 0,
    height: 11.11,
    scale: 3,
    isOpticalZoom: !1,
    defaultZoom: 2
  }, {
    zoomNum: 5,
    zoom: '5x',
    bottom: 11.11,
    height: 33.33,
    scale: 5,
    isOpticalZoom: !0,
    defaultZoom: 2
  }, {
    zoomNum: 10,
    zoom: '10x',
    bottom: 44.44,
    height: 33.33,
    scale: 5,
    isOpticalZoom: !0,
    defaultZoom: 2
  }, {
    zoomNum: 20,
    zoom: '20x',
    bottom: 77.77,
    height: 22.23,
    scale: 9,
    isOpticalZoom: !0,
    defaultZoom: 2
  }, {
    zoomNum: 200,
    zoom: '200x',
    bottom: 100,
    height: 0,
    scale: 0,
    isOpticalZoom: !1,
    defaultZoom: 2
  }],
  [DRONE_TYPE.Mavic3EnterpriseAdvanced]: [{
    zoomNum: 1,
    zoom: '1x',
    bottom: 0,
    height: 22.22,
    scale: 4,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 2,
    zoom: '2x',
    bottom: 22.22,
    height: 22.22,
    scale: 5,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 7,
    zoom: '7x',
    bottom: 44.44,
    height: 33.33,
    scale: 7,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 14,
    zoom: '14x',
    bottom: 77.77,
    height: 22.23,
    scale: 14,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 56,
    zoom: '56x',
    bottom: 100,
    height: 0,
    scale: 0,
    isOpticalZoom: !1,
    defaultZoom: 1
  }],
  [DRONE_TYPE.M3D]: [{
    zoomNum: 1,
    zoom: '1x',
    bottom: 0,
    height: 22.22,
    scale: 4,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 2,
    zoom: '2x',
    bottom: 22.22,
    height: 22.22,
    scale: 5,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 7,
    zoom: '7x',
    bottom: 44.44,
    height: 33.33,
    scale: 7,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 14,
    zoom: '14x',
    bottom: 77.77,
    height: 22.23,
    scale: 14,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 56,
    zoom: '56x',
    bottom: 100,
    height: 0,
    scale: 0,
    isOpticalZoom: !1,
    defaultZoom: 1
  }],
  [DRONE_TYPE.Mavic4EnterpriseAdvanced]: [{
    zoomNum: 1,
    zoom: '1x',
    bottom: 0,
    height: 20,
    scale: 4,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 3,
    zoom: '3x',
    bottom: 20,
    height: 20,
    scale: 4,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 7,
    zoom: '7x',
    bottom: 40,
    height: 20,
    scale: 7,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 14,
    zoom: '14x',
    bottom: 60,
    height: 20,
    scale: 7,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 56,
    zoom: '56x',
    bottom: 80,
    height: 20,
    scale: 8,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 112,
    zoom: '112x',
    bottom: 100,
    height: 0,
    scale: 0,
    isOpticalZoom: !1,
    defaultZoom: 1
  }],
  [DRONE_TYPE.M4D]: [{
    zoomNum: 1,
    zoom: '1x',
    bottom: 0,
    height: 20,
    scale: 4,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 3,
    zoom: '3x',
    bottom: 20,
    height: 20,
    scale: 4,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 7,
    zoom: '7x',
    bottom: 40,
    height: 20,
    scale: 7,
    isOpticalZoom: !0,
    defaultZoom: 1
  }, {
    zoomNum: 14,
    zoom: '14x',
    bottom: 60,
    height: 20,
    scale: 7,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 56,
    zoom: '56x',
    bottom: 80,
    height: 20,
    scale: 8,
    isOpticalZoom: !1,
    defaultZoom: 1
  }, {
    zoomNum: 112,
    zoom: '112x',
    bottom: 100,
    height: 0,
    scale: 0,
    isOpticalZoom: !1,
    defaultZoom: 1
  }]
}

export const ZOOM_SCALE_POINT = { 67: [{ zoomNum: 2, zoom: '2x', bottom: 0, height: 11.11, scale: 3, isOpticalZoom: false, defaultZoom: 2 }, { zoomNum: 5, zoom: '5x', bottom: 11.11, height: 33.33, scale: 5, isOpticalZoom: true, defaultZoom: 2 }, { zoomNum: 10, zoom: '10x', bottom: 44.44, height: 33.33, scale: 5, isOpticalZoom: true, defaultZoom: 2 }, { zoomNum: 20, zoom: '20x', bottom: 77.77, height: 22.23, scale: 9, isOpticalZoom: true, defaultZoom: 2 }, { zoomNum: 200, zoom: '200x', bottom: 100, height: 0, scale: 0, isOpticalZoom: false, defaultZoom: 2 }], 77: [{ zoomNum: 1, zoom: '1x', bottom: 0, height: 22.22, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 2, zoom: '2x', bottom: 22.22, height: 22.22, scale: 5, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 7, zoom: '7x', bottom: 44.44, height: 33.33, scale: 7, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 14, zoom: '14x', bottom: 77.77, height: 22.23, scale: 14, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 56, zoom: '56x', bottom: 100, height: 0, scale: 0, isOpticalZoom: false, defaultZoom: 1 }], 91: [{ zoomNum: 1, zoom: '1x', bottom: 0, height: 22.22, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 2, zoom: '2x', bottom: 22.22, height: 22.22, scale: 5, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 7, zoom: '7x', bottom: 44.44, height: 33.33, scale: 7, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 14, zoom: '14x', bottom: 77.77, height: 22.23, scale: 14, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 56, zoom: '56x', bottom: 100, height: 0, scale: 0, isOpticalZoom: false, defaultZoom: 1 }], 99: [{ zoomNum: 1, zoom: '1x', bottom: 0, height: 20, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 3, zoom: '3x', bottom: 20, height: 20, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 7, zoom: '7x', bottom: 40, height: 20, scale: 7, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 14, zoom: '14x', bottom: 60, height: 20, scale: 7, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 56, zoom: '56x', bottom: 80, height: 20, scale: 8, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 112, zoom: '112x', bottom: 100, height: 0, scale: 0, isOpticalZoom: false, defaultZoom: 1 }], 100: [{ zoomNum: 1, zoom: '1x', bottom: 0, height: 20, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 3, zoom: '3x', bottom: 20, height: 20, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 7, zoom: '7x', bottom: 40, height: 20, scale: 7, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 14, zoom: '14x', bottom: 60, height: 20, scale: 7, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 56, zoom: '56x', bottom: 80, height: 20, scale: 8, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 112, zoom: '112x', bottom: 100, height: 0, scale: 0, isOpticalZoom: false, defaultZoom: 1 }], 260: [{ zoomNum: 1, zoom: '1x', bottom: 0, height: 20, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 3, zoom: '3x', bottom: 20, height: 20, scale: 4, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 7, zoom: '7x', bottom: 40, height: 20, scale: 7, isOpticalZoom: true, defaultZoom: 1 }, { zoomNum: 14, zoom: '14x', bottom: 60, height: 20, scale: 7, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 56, zoom: '56x', bottom: 80, height: 20, scale: 8, isOpticalZoom: false, defaultZoom: 1 }, { zoomNum: 160, zoom: '160x', bottom: 100, height: 0, scale: 0, isOpticalZoom: false, defaultZoom: 1 }] }
export const PAYLOAD_TRY_TYPE: { [x: string | number]: string | number } = {
  20: 'Z30',
  26: 'XT2',
  39: 'FPV',
  41: 'XTS',
  42: 'H20',
  43: 'H20T',
  50: 'EP600',
  52: 'M30',
  53: 'M30T',
  61: 'H20N',
  66: 'M3E',
  67: 'M3T',
  80: 'M3D',
  81: 'M3TD',
  88: 'M4E',
  89: 'M4T',
  98: 'M4D',
  99: 'M4TD',
  165: 'DockTopCamera',
  90742: 'EP800',
  FPV: 39,
  H20: 42,
  H20T: 43,
  H20N: 61,
  EP600: 50,
  EP800: 90742,
  M30D: 52,
  M30T: 53,
  XT2: 26,
  XTS: 41,
  Z30: 20,
  DockTopCamera: 165,
  M3E: 66,
  M3T: 67,
  M3D: 80,
  M3TD: 81,
  M4E: 88,
  M4T: 89,
  M4D: 98,
  M4TD: 99
}
export const DroneSubEnumValue = {
  [PAYLOAD_TRY_TYPE.M30D]: 0,
  [PAYLOAD_TRY_TYPE.M30T]: 1,
  [PAYLOAD_TRY_TYPE.M3E]: 0,
  [PAYLOAD_TRY_TYPE.M3T]: 1,
  [PAYLOAD_TRY_TYPE.M3D]: 0,
  [PAYLOAD_TRY_TYPE.M3TD]: 1,
  [PAYLOAD_TRY_TYPE.M4E]: 0,
  [PAYLOAD_TRY_TYPE.M4T]: 1,
  [PAYLOAD_TRY_TYPE.M4D]: 0,
  [PAYLOAD_TRY_TYPE.M4TD]: 1
}
export const PayloadSubEnumValue = {
  [PAYLOAD_TRY_TYPE.M30D]: 0,
  [PAYLOAD_TRY_TYPE.M30T]: 2,
  [PAYLOAD_TRY_TYPE.M3E]: 0,
  [PAYLOAD_TRY_TYPE.M3T]: 2,
  [PAYLOAD_TRY_TYPE.M3D]: 0,
  [PAYLOAD_TRY_TYPE.M3TD]: 2,
  [PAYLOAD_TRY_TYPE.M4E]: 0,
  [PAYLOAD_TRY_TYPE.M4T]: 2,
  [PAYLOAD_TRY_TYPE.M4D]: 0,
  [PAYLOAD_TRY_TYPE.M4TD]: 2,
}

export const PayloadSubEnumValue2 = {
  [PAYLOAD_TRY_TYPE.M30D]: 0,
  [PAYLOAD_TRY_TYPE.M30T]: 0,
  [PAYLOAD_TRY_TYPE.M3E]: 0,
  [PAYLOAD_TRY_TYPE.M3T]: 0,
  [PAYLOAD_TRY_TYPE.M3D]: 0,
  [PAYLOAD_TRY_TYPE.M3TD]: 0,
  [PAYLOAD_TRY_TYPE.M4E]: 0,
  [PAYLOAD_TRY_TYPE.M4T]: 0,
  [PAYLOAD_TRY_TYPE.M4D]: 0,
  [PAYLOAD_TRY_TYPE.M4TD]: 0,
}
export const DRONE_WAYLINE_TYPE = {
  60: 'M300',
  67: 'M30',
  77: 'Mavic3EnterpriseAdvanced',
  89: 'M350',
  91: 'M3D',
  99: 'Matrice4Enterprise',
  100: 'M4D',
  103: 'M400',
  M3D: 91,
  M4D: 100,
  M30: 67,
  M300: 60,
  M350: 89,
  M400: 103,
  Matrice4Enterprise: 99,
  Mavic3EnterpriseAdvanced: 77
}
// DJI负载类型枚举值
export const PAYLOAD_TYPE = {
  39: 'FPV',
  42: 'H20',
  43: 'H20T',
  61: 'H20N',
  82: 'H30',
  83: 'H30T',
  50: 'EP600',
  90742: 'EP800',
  52: 'M30D',
  53: 'M30T',
  26: 'XT2',
  41: 'XTS',
  20: 'Z30',
  165: 'DockTopCamera',
  66: 'M3E',
  67: 'M3T',
  68: 'M3M',
  80: 'M3D',
  81: 'M3TD',
  176: 'M3DC',
  88: 'M4E',
  89: 'M4T',
  129: 'M3TA',
  98: 'M4D',
  99: 'M4TD',
  FPV: 39,
  H20: 42,
  H20T: 43,
  H20N: 61,
  H30: 82,
  H30T: 83,
  EP600: 50,
  EP800: 90742,
  M30D: 52,
  M30T: 53,
  XT2: 26,
  XTS: 41,
  Z30: 20,
  DockTopCamera: 165,

  M3E: 66,
  M3T: 67,
  M3M: 68,
  M3D: 80,
  M3TD: 81,
  M3DC: 176,
  M4E: 88,
  M4T: 89,
  M3TA: 129,
  M4D: 98,
  M4TD: 99,
  // UNKNOWN = 65535
}

export const DRONE_ROTATE_ANGLE = {
  [PAYLOAD_TYPE.M30D]: [-120, 45],
  [PAYLOAD_TYPE.M30T]: [-120, 45],
  [PAYLOAD_TYPE.M3E]: [-90, 35],
  [PAYLOAD_TYPE.M3T]: [-90, 35],
  [PAYLOAD_TYPE.M3D]: [-90, 30],
  [PAYLOAD_TYPE.M3TD]: [-90, 30],
  [PAYLOAD_TYPE.M4E]: [-90, 35],
  [PAYLOAD_TYPE.M4T]: [-90, 70],
  [PAYLOAD_TYPE.M4D]: [-90, 35],
  [PAYLOAD_TYPE.M4TD]: [-90, 35]
}

export const DEVICE_SERVER_LIST = [{
  label: '经纬 M30 系列',
  value: DRONE_TYPE.M30
}, {
  label: 'Mavic 3 行业系列',
  value: DRONE_TYPE.Mavic3EnterpriseAdvanced
}, {
  label: 'Matrice 3D 系列',
  value: DRONE_TYPE.M3D
}, {
  label: 'Matrice 4 行业系列',
  value: DRONE_TYPE.Mavic4EnterpriseAdvanced
}, {
  label: 'Matrice 4D 系列',
  value: DRONE_TYPE.M4D
}]
export const DEVICE_CAMERA_LIST: { [x: number]: { value: number, label: string }[] } = {
  [DRONE_TYPE.M30]: [{
    value: PAYLOAD_TRY_TYPE.M30D,
    label: 'Matrice 30 相机'
  }, {
    value: PAYLOAD_TRY_TYPE.M30T,
    label: 'Matrice 30T 相机'
  }],
  [DRONE_TYPE.Mavic3EnterpriseAdvanced]: [{
    value: PAYLOAD_TRY_TYPE.M3E,
    label: 'Mavic 3E 相机'
  }, {
    value: PAYLOAD_TRY_TYPE.M3T,
    label: 'Mavic 3T 相机'
  }],
  [DRONE_TYPE.M3D]: [{
    value: PAYLOAD_TRY_TYPE.M3D,
    label: 'Matrice 3D 相机'
  }, {
    value: PAYLOAD_TRY_TYPE.M3TD,
    label: 'Matrice 3TD 相机'
  }],
  [DRONE_TYPE.Mavic4EnterpriseAdvanced]: [{
    value: PAYLOAD_TRY_TYPE.M4E,
    label: 'Matrice 4E 相机'
  }, {
    value: PAYLOAD_TRY_TYPE.M4T,
    label: 'Matrice 4T 相机'
  }],
  [DRONE_TYPE.M4D]: [{
    value: PAYLOAD_TRY_TYPE.M4D,
    label: 'Matrice 4D 相机'
  }, {
    value: PAYLOAD_TRY_TYPE.M4TD,
    label: 'Matrice 4TD 相机'
  }]
}

export const DEVICE_VALUES = [{
  label: 'M350/M300 RTK',
  value: '0-60-0,0-89-0'
}, {
  label: '经纬 M30 系列',
  value: '0-67-0,0-67-1'
}, {
  label: 'Mavic 3 行业系列',
  value: '0-77-0,0-77-1,0-77-2'
}, {
  label: 'Matrice 3D 系列',
  value: '0-91-0,0-91-1'
}, {
  label: 'Matrice 4 行业系列',
  value: '0-99-0,0-99-1'
}, {
  label: 'Matrice 4D 系列',
  value: '0-100-0,0-100-1'
}]

export const CAMERA_PAYLOAD = {
  [DRONE_TYPE.M30]: {
    psdkList: ['LP12'],
    actions: [DEVICE_TYPE.START_MP20_LIGHTFLASH, DEVICE_TYPE.STOP_MP20_LIGHTFLASH, DEVICE_TYPE.START_SPEAKER_PLAY],
    multiple: false
  },
  [DRONE_TYPE.Mavic3EnterpriseAdvanced]: {
    psdkList: [],
    actions: [],
    multiple: false
  },
  [DRONE_TYPE.M3D]: {
    psdkList: ['MP20', 'LP20'],
    actions: [DEVICE_TYPE.START_MP20_LIGHTFLASH, DEVICE_TYPE.STOP_MP20_LIGHTFLASH, DEVICE_TYPE.START_SPEAKER_PLAY],
    multiple: false
  },
  [DRONE_TYPE.Mavic4EnterpriseAdvanced]: {
    psdkList: ['AS1', 'AL1'],
    actions: [WaylineActionType.SEARCH_LIGHT, WaylineActionType.SEARCH_LIGHT_STOP, WaylineActionType.MEGAPHONE, WaylineActionType.MEGAPHONE_STOP],
    multiple: true
  },
  [DRONE_TYPE.M4D]: {
    psdkList: ['AS1', 'AL1'],
    actions: [WaylineActionType.SEARCH_LIGHT, WaylineActionType.SEARCH_LIGHT_STOP, WaylineActionType.MEGAPHONE, WaylineActionType.MEGAPHONE_STOP],
    multiple: true
  }
}

export const DEVICE_CAMERA_SET = {
  czi: {
    light: [DEVICE_TYPE.START_MP20_LIGHTFLASH, DEVICE_TYPE.STOP_MP20_LIGHTFLASH],
    speaker: [DEVICE_TYPE.START_SPEAKER_PLAY]
  },
  dji: {
    light: [WaylineActionType.SEARCH_LIGHT, WaylineActionType.SEARCH_LIGHT_STOP],
    speaker: [WaylineActionType.MEGAPHONE, WaylineActionType.MEGAPHONE_STOP]
  }
}
export const DEVICE_CAMERA_DIR = {
  [PAYLOAD_TRY_TYPE.M30D]: ['wide'],
  [PAYLOAD_TRY_TYPE.M30T]: ['wide', 'ir'],
  [PAYLOAD_TRY_TYPE.M3E]: ['visable'],
  [PAYLOAD_TRY_TYPE.M3T]: ['visable', 'ir'],
  [PAYLOAD_TRY_TYPE.M3D]: ['visable'],
  [PAYLOAD_TRY_TYPE.M3TD]: ['visable', 'ir'],
  [PAYLOAD_TRY_TYPE.M4E]: ['visable'],
  [PAYLOAD_TRY_TYPE.M4T]: ['visable', 'ir'],
  [PAYLOAD_TRY_TYPE.M4D]: ['visable'],
  [PAYLOAD_TRY_TYPE.M4TD]: ['visable', 'ir']
}
export const PAYLOAD_WIDE_IR = {
  [PAYLOAD_TRY_TYPE.M30D]: {
    wideS: 1.6,
    wideF: 4.5
  },
  [PAYLOAD_TRY_TYPE.M30T]: {
    wideS: 1.6,
    wideF: 4.5,
    irS: 12,
    irF: 9.1
  },
  [PAYLOAD_TRY_TYPE.M3E]: {
    wideS: 3.3,
    wideW: 17.4,
    wideF: 12.29
  },
  [PAYLOAD_TRY_TYPE.M3T]: {
    wideS: 0.8 * 2,
    wideW: 6.4,
    wideF: 4.4,
    irS: 12,
    irW: 7.68,
    irF: 9.1
  },
  [PAYLOAD_TRY_TYPE.M3D]: {
    wideS: 3.3,
    wideW: 17.4,
    wideF: 12.29
  },
  [PAYLOAD_TRY_TYPE.M3TD]: {
    wideS: 1.197 * 2,
    wideW: 9.691,
    wideF: 6.78,
    irS: 12,
    irW: 7.68,
    irF: 9.1
  },
  [PAYLOAD_TRY_TYPE.M4E]: {
    wideS: 3.3,
    wideW: 17.4,
    wideF: 12.287
  },
  [PAYLOAD_TRY_TYPE.M4T]: {
    wideS: 1.197 * 2,
    wideW: 9.69,
    wideF: 6.73,
    irS: 12,
    irW: 7.68,
    irF: 12
  },
  [PAYLOAD_TRY_TYPE.M4D]: {
    wideS: 3.3,
    wideW: 17.4,
    wideF: 12.287
  },
  [PAYLOAD_TRY_TYPE.M4TD]: {
    wideS: 1.197 * 2,
    wideW: 9.69,
    wideF: 6.73,
    irS: 12,
    irW: 7.68,
    irF: 12
  }
}
// 常量定义
export const acquisitionTypes = {
  MAPPING2D: 1,
  MAPPING3D: 2
}

export const shootTypes = {
  TIME: 1,
  DISTANCE: 2
}
const SHOOT_TYPES = {
  TIME: 'time',
  DISTANCE: 'distance'
}
export const cameraTypes = {
  WIDE: 'wide',
  VISABLE: 'visable',
  IR: 'ir'
}
export const CAMERA_TYPES = {
  Ir: 'ir',
  Visable: 'visable',
  Wide: 'wide'
}
export const heightModes = {
  EGM96: 'egm96',
  RELATIVE_TO_START_POINT: 'relative_to_start_point',
  ABOVE_GROUND_LEVEL: 'above_ground_level'
}
export const finishActions = {
  GO_HOME: 0,
  GOTO_FIRST_WAYPOINT: 1,
  NO_ACTION: 2,
  AUTO_LAND: 3
}

export const imageFormatLabels = {
  [cameraTypes.WIDE]: '广角',
  [cameraTypes.VISABLE]: '可见光',
  [cameraTypes.IR]: '红外'
}
// 不同负载类型可用的图像格式
export const availableImageFormats = {
  [PAYLOAD_TYPE.M30D]: [cameraTypes.WIDE], // M30相机
  [PAYLOAD_TYPE.M30T]: [cameraTypes.WIDE, cameraTypes.IR], // M30T相机
  [PAYLOAD_TRY_TYPE.M3E]: [cameraTypes.VISABLE],
  [PAYLOAD_TRY_TYPE.M3T]: [cameraTypes.VISABLE, cameraTypes.IR],
  [PAYLOAD_TRY_TYPE.M3D]: [cameraTypes.VISABLE],
  [PAYLOAD_TRY_TYPE.M3TD]: [cameraTypes.VISABLE, cameraTypes.IR],
  [PAYLOAD_TRY_TYPE.M4E]: [cameraTypes.VISABLE],
  [PAYLOAD_TRY_TYPE.M4T]: [cameraTypes.VISABLE, cameraTypes.IR],
  [PAYLOAD_TRY_TYPE.M4D]: [cameraTypes.VISABLE],
  [PAYLOAD_TRY_TYPE.M4TD]: [cameraTypes.VISABLE, cameraTypes.IR],
  54: [cameraTypes.VISABLE, cameraTypes.IR] // 其他相机类型
}
export const hideAction = [WaylineActionType.SEARCH_LIGHT, WaylineActionType.SEARCH_LIGHT_STOP, WaylineActionType.MEGAPHONE, WaylineActionType.MEGAPHONE_STOP]
export const disabledAction = ['startMP20LightFlash', 'startArRecord', 'stopArRecord', 'stopMP20LightFlash', 'startSpeakerPlay', WaylineActionType.SEARCH_LIGHT, WaylineActionType.SEARCH_LIGHT_STOP, WaylineActionType.MEGAPHONE, WaylineActionType.MEGAPHONE_STOP]
export const actionList = [{
  name: '拍照',
  actions: ['takePhoto', 'panoShot', 'multipleTiming', 'multipleDistance', 'multipleEnd', 'zoom']
}, {
  name: '录像',
  actions: ['startRecord', 'stopRecord', 'startArRecord', 'stopArRecord']
}, {
  name: '云台',
  actions: ['gimbalRotateYaw', 'gimbalRotatePitch']
}, {
  name: '负载',
  actions: ['startMP20LightFlash', 'stopMP20LightFlash', 'startSpeakerPlay', WaylineActionType.SEARCH_LIGHT, WaylineActionType.SEARCH_LIGHT_STOP, WaylineActionType.MEGAPHONE, WaylineActionType.MEGAPHONE_STOP]
}, {
  name: 'AI识别',
  actions: ['startAI', 'stopAI']
}, {
  name: '飞行',
  actions: ['hover', 'rotateYaw']
}, {
  name: '其他',
  actions: ['customDirName']
}]
export const DEVICE_CAMERA_DIR_ARR = ['wide', 'zoom', 'ir', 'visable']
export const DEVICE_CAMERA_DIR_NAME = {
  wide: '广角照片',
  zoom: '变焦照片',
  ir: '红外照片',
  visable: '可见光'
}
// 手柄类型
export enum RC_TYPE {
  RC = 56, // DJI Smart Controller
  RCPlus = 119, // DJI RC Plus
  RC144 = 144, // DJI RC Pro
  RCPlus2 = 174, // DJI RC Plus 2
}

// 机场类型
export enum DOCK_TYPE {
  Dock = 1,
  Dock2 = 2,
  Dock3 = 3,
}

export const PayloadWithIRCamera = [53, 67, 81, 89, 99]
// 设备sub_type 从0升序
export enum DEVICE_SUB_TYPE {
  ZERO,
  ONE,
  TWO,
  THREE,
  UNKNOWN = 65535,
}

export const DRONE_DEVICE_IMG_TYPE = {
  // 无人机图片枚举
  M4D: drone3,
  M3D: drone2,
  M30: drone,
}

export const DOCK_DEVICE_IMG_TYPE = {
  // 机场图片枚举
  Dock3: dock3,
  Dock2: dock2,
  Dock: dock,
}

export const DEVICE_MODEL_KEY: { [x: string]: string } = {
  M30: `${DOMAIN.DRONE}-${DRONE_TYPE.M30}-${DEVICE_SUB_TYPE.ZERO}`,
  M30T: `${DOMAIN.DRONE}-${DRONE_TYPE.M30}-${DEVICE_SUB_TYPE.ONE}`,

  M3E: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic3EnterpriseAdvanced}-${DEVICE_SUB_TYPE.ZERO}`,
  M3T: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic3EnterpriseAdvanced}-${DEVICE_SUB_TYPE.ONE}`,
  M3M: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic3EnterpriseAdvanced}-${DEVICE_SUB_TYPE.TWO}`,

  M4E: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic4EnterpriseAdvanced}-${DEVICE_SUB_TYPE.ZERO}`,
  M4T: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic4EnterpriseAdvanced}-${DEVICE_SUB_TYPE.ONE}`,

  M300: `${DOMAIN.DRONE}-${DRONE_TYPE.M300}-${DEVICE_SUB_TYPE.ZERO}`,
  M350: `${DOMAIN.DRONE}-${DRONE_TYPE.M350}-${DEVICE_SUB_TYPE.ZERO}`,

  M3D: `${DOMAIN.DRONE}-${DRONE_TYPE.M3D}-${DEVICE_SUB_TYPE.ZERO}`,
  M3TD: `${DOMAIN.DRONE}-${DRONE_TYPE.M3D}-${DEVICE_SUB_TYPE.ONE}`,

  M4D: `${DOMAIN.DRONE}-${DRONE_TYPE.M4D}-${DEVICE_SUB_TYPE.ZERO}`,
  M4TD: `${DOMAIN.DRONE}-${DRONE_TYPE.M4D}-${DEVICE_SUB_TYPE.ONE}`,

  FPV: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.FPV}-${DEVICE_SUB_TYPE.ZERO}`,
  H20: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H20}-${DEVICE_SUB_TYPE.ZERO}`,
  H20T: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H20T}-${DEVICE_SUB_TYPE.ZERO}`,
  H20N: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H20N}-${DEVICE_SUB_TYPE.ZERO}`,
  H30: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H30}-${DEVICE_SUB_TYPE.ZERO}`,
  H30T: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H30T}-${DEVICE_SUB_TYPE.ZERO}`,
  EP600: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.EP600}-${DEVICE_SUB_TYPE.UNKNOWN}`,
  EP800: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.EP800}-${DEVICE_SUB_TYPE.ZERO}`,
  M30Camera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M30D}-${DEVICE_SUB_TYPE.ZERO}`,
  M30TCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M30T}-${DEVICE_SUB_TYPE.ZERO}`,

  M3ECamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3E}-${DEVICE_SUB_TYPE.ZERO}`,
  M3TCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3T}-${DEVICE_SUB_TYPE.ZERO}`,
  M3DCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3D}-${DEVICE_SUB_TYPE.ZERO}`,
  M3TDCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3TD}-${DEVICE_SUB_TYPE.ZERO}`,
  M4ECamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M4E}-${DEVICE_SUB_TYPE.ZERO}`,
  M4TCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M4T}-${DEVICE_SUB_TYPE.ZERO}`,
  M4DCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M4D}-${DEVICE_SUB_TYPE.ZERO}`,
  M4TDCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M4TD}-${DEVICE_SUB_TYPE.ZERO}`,
  M3MCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3M}-${DEVICE_SUB_TYPE.ZERO}`,

  XT2: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.XT2}-${DEVICE_SUB_TYPE.ZERO}`,
  XTS: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.XTS}-${DEVICE_SUB_TYPE.ZERO}`,
  Z30: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.Z30}-${DEVICE_SUB_TYPE.ZERO}`,
  DockTopCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.DockTopCamera}-${DEVICE_SUB_TYPE.ZERO}`,

  RC: `${DOMAIN.RC}-${RC_TYPE.RC}-${DEVICE_SUB_TYPE.ZERO}`,
  RCPlus: `${DOMAIN.RC}-${RC_TYPE.RCPlus}-${DEVICE_SUB_TYPE.ZERO}`,
  RCPlus2: `${DOMAIN.RC}-${RC_TYPE.RCPlus2}-${DEVICE_SUB_TYPE.ZERO}`,

  Dock: `${DOMAIN.DOCK}-${DOCK_TYPE.Dock}-${DEVICE_SUB_TYPE.ZERO}`,
  Dock2: `${DOMAIN.DOCK}-${DOCK_TYPE.Dock2}-${DEVICE_SUB_TYPE.ZERO}`,
  Dock3: `${DOMAIN.DOCK}-${DOCK_TYPE.Dock3}-${DEVICE_SUB_TYPE.ZERO}`,
}

export const TYPE_IMG_DOCK_CODE = {
  [DEVICE_MODEL_KEY.Dock]: DOCK_DEVICE_IMG_TYPE.Dock,
  [DEVICE_MODEL_KEY.Dock2]: DOCK_DEVICE_IMG_TYPE.Dock2,
  [DEVICE_MODEL_KEY.Dock3]: DOCK_DEVICE_IMG_TYPE.Dock3
}

export const TYPE_IMG_DRONE_CODE = {
  [DEVICE_MODEL_KEY.M4D]: DRONE_DEVICE_IMG_TYPE.M4D,
  [DEVICE_MODEL_KEY.M4TD]: DRONE_DEVICE_IMG_TYPE.M4D,
  [DEVICE_MODEL_KEY.M3D]: DRONE_DEVICE_IMG_TYPE.M3D,
  [DEVICE_MODEL_KEY.M3TD]: DRONE_DEVICE_IMG_TYPE.M3D,
  [DEVICE_MODEL_KEY.M30]: DRONE_DEVICE_IMG_TYPE.M30
}

export const DEVICE_NAME = {
  // 飞行器
  [DEVICE_MODEL_KEY.M30]: 'M30',
  [DEVICE_MODEL_KEY.M30T]: 'M30T',
  [DEVICE_MODEL_KEY.M3E]: 'Mavic 3E',
  [DEVICE_MODEL_KEY.M3T]: 'Mavic 3T',
  [DEVICE_MODEL_KEY.M3M]: 'Mavic 3M',
  [DEVICE_MODEL_KEY.M300]: 'M300 RTK',
  [DEVICE_MODEL_KEY.M350]: 'M350 RTK',
  [DEVICE_MODEL_KEY.M3D]: 'M3D',
  [DEVICE_MODEL_KEY.M3TD]: 'M3TD',
  [DEVICE_MODEL_KEY.M4D]: 'M4D',
  [DEVICE_MODEL_KEY.M4TD]: 'M4TD',

  // 负载
  [DEVICE_MODEL_KEY.FPV]: 'FPV',
  [DEVICE_MODEL_KEY.H20]: 'H20',
  [DEVICE_MODEL_KEY.H20T]: 'H20T',
  [DEVICE_MODEL_KEY.H30]: 'H30',
  [DEVICE_MODEL_KEY.H30T]: 'H30T',
  [DEVICE_MODEL_KEY.H20N]: 'H20N',
  [DEVICE_MODEL_KEY.EP600]: 'P1',
  [DEVICE_MODEL_KEY.EP800]: 'L1',
  [DEVICE_MODEL_KEY.M30Camera]: 'M30 Camera',
  [DEVICE_MODEL_KEY.M30TCamera]: 'M30T Camera',
  [DEVICE_MODEL_KEY.M3ECamera]: 'Mavic 3E',
  [DEVICE_MODEL_KEY.M3TCamera]: 'Mavic 3T',
  [DEVICE_MODEL_KEY.M3MCamera]: 'Mavic 3M',
  [DEVICE_MODEL_KEY.M4ECamera]: 'Mavic 4E',
  [DEVICE_MODEL_KEY.M4TCamera]: 'Mavic 4T',
  [DEVICE_MODEL_KEY.XT2]: 'XT2',
  [DEVICE_MODEL_KEY.XTS]: 'XTS',
  [DEVICE_MODEL_KEY.Z30]: 'Z30',
  [DEVICE_MODEL_KEY.DockTopCamera]: 'Dock Camera',
  [DEVICE_MODEL_KEY.M3DCamera]: 'M3D Camera',
  [DEVICE_MODEL_KEY.M3TDCamera]: 'M3TD Camera',
  [DEVICE_MODEL_KEY.M4DCamera]: 'M4D Camera',
  [DEVICE_MODEL_KEY.M4TDCamera]: 'M4TD Camera',

  // 手柄
  [DEVICE_MODEL_KEY.RC]: 'RC',
  [DEVICE_MODEL_KEY.RCPlus]: 'RC Plus',
  [DEVICE_MODEL_KEY.RCPlus2]: 'RC Plus2',

  // 机场
  [DEVICE_MODEL_KEY.Dock]: 'Dock',
  [DEVICE_MODEL_KEY.Dock2]: 'Dock2',
  [DEVICE_MODEL_KEY.Dock3]: 'Dock3',
}
export const deviceSerie = [
  {
    value: DRONE_TYPE.M30,
    name: '经纬 M30 系列',
    children: [
      { value: DEVICE_MODEL_KEY.M30, name: DEVICE_NAME[DEVICE_MODEL_KEY.M30] },
      { value: DEVICE_MODEL_KEY.M30T, name: DEVICE_NAME[DEVICE_MODEL_KEY.M30T] }
    ]
  },
  {
    value: DRONE_TYPE.Mavic3EnterpriseAdvanced,
    name: 'Mavic 3 行业系列',
    children: [
      { value: DEVICE_MODEL_KEY.M3E, name: DEVICE_NAME[DEVICE_MODEL_KEY.M3E] },
      { value: DEVICE_MODEL_KEY.M3T, name: DEVICE_NAME[DEVICE_MODEL_KEY.M3T] }
    ]
  },
  {
    value: DRONE_TYPE.M3D,
    name: 'Matrice 3D 系列',
    children: [
      { value: DEVICE_MODEL_KEY.M3D, name: DEVICE_NAME[DEVICE_MODEL_KEY.M3D] },
      { value: DEVICE_MODEL_KEY.M3TD, name: DEVICE_NAME[DEVICE_MODEL_KEY.M3TD] }
    ]
  },
  {
    value: DRONE_TYPE.Mavic4EnterpriseAdvanced,
    name: 'Mavic 4 行业系列',
    children: [
      { value: DEVICE_MODEL_KEY.M4E, name: DEVICE_NAME[DEVICE_MODEL_KEY.M4E] },
      { value: DEVICE_MODEL_KEY.M4T, name: DEVICE_NAME[DEVICE_MODEL_KEY.M4T] }
    ]
  },
  {
    value: DRONE_TYPE.M4D,
    name: 'Matrice 4D 系列',
    children: [
      { value: DEVICE_MODEL_KEY.M4D, name: DEVICE_NAME[DEVICE_MODEL_KEY.M4D] },
      { value: DEVICE_MODEL_KEY.M4TD, name: DEVICE_NAME[DEVICE_MODEL_KEY.M4TD] }
    ]
  }
]
// 控制权
export enum ControlSource {
  A = 'A',
  B = 'B'
}

// 负载信息
export interface PayloadInfo {
  index: number,
  model: string,
  control_source?: ControlSource,
  payload_sn?: string,
  payload_index?: string,
  payload_name?: string,
}

// 设备信息
export interface OnlineDevice {
  model: string,
  callsign: string,
  sn: string,
  mode: number,
  domain: string,
  type: string,
  sub_type: string,
  gateway: {
    model: string,
    callsign: string,
    sn: string,
    childSn?: string,
    domain: string,
    lon: string,
    lat: string,
    type: string,
    sub_type: string,
    id?: number
  },
  payload: PayloadInfo[]
}

// 固件升级类型
export enum DeviceFirmwareTypeEnum {
  ToUpgraded = 3, // 普通升级
  ConsistencyUpgrade = 2, // 一致性升级
}

// 固件升级状态
export enum DeviceFirmwareStatusEnum {
  None = 1, // 无需升级
  ToUpgraded = 2, // 待升级
  ConsistencyUpgrade = 3, // 一致性升级
  DuringUpgrade = 4, // 升级中
}

export const DeviceFirmwareStatus = {
  [DeviceFirmwareStatusEnum.None]: '',
  [DeviceFirmwareStatusEnum.ToUpgraded]: '待升级',
  [DeviceFirmwareStatusEnum.ConsistencyUpgrade]: '一致性升级',
  [DeviceFirmwareStatusEnum.DuringUpgrade]: '升级中',
}

export const DeviceFirmwareStatusColor = {
  [DeviceFirmwareStatusEnum.None]: commonColor.WHITE,
  [DeviceFirmwareStatusEnum.ToUpgraded]: commonColor.BLUE,
  [DeviceFirmwareStatusEnum.ConsistencyUpgrade]: commonColor.WARN,
  [DeviceFirmwareStatusEnum.DuringUpgrade]: commonColor.NORMAL,
}

export interface Device {
  device_name: string,
  device_sn: string,
  nickname: string,
  firmware_version: string,
  firmware_status: DeviceFirmwareStatusEnum,
  status: string,
  workspace_name: string,
  bound_time: string,
  login_time: string,
  children?: Device[],
  domain: number,
  type: number,
  firmware_progress?: string, // 升级进度
}

export interface DeviceStatus {
  sn: string,
  online_status: boolean,
  device_callsign: string,
  user_id: string,
  user_callsign: string
  bound_status: boolean,
  model: string,
  gateway_sn: string,
  domain: number
}

export interface OSDVisible {
  sn: string,
  model: string,
  callsign: string,
  visible: boolean,
  is_dock: boolean,
  gateway_sn: string,
  gateway_callsign: string,
  payloads: null | PayloadInfo[],
}
export enum WirelessLink4gEnum {
  LINKSTATE = '4g_link_state', // 4g链路连接状态
  QUALITY = '4g_quality', // 4g信号质量
  FREQBAND = '4g_freq_band', // 4G频段
  GNDQUALITY = '4g_gnd_quality', // 4G下行链路质量
  UAVQUALITY = '4g_uav_quality', // 4G上行链路质量
}
export interface GatewayOsd {
  capacity_percent: string,
  transmission_signal_quality: string,
  longitude: number,
  latitude: number,
  wireless_link:{
     [WirelessLink4gEnum.FREQBAND]: number, // 4G频段
    [WirelessLink4gEnum.GNDQUALITY]: number, // 地面端（如遥控器、DJI Dock等）与 4G 服务器之间的信号质量 {"max":"5","min":"0","step":"1"}
    [WirelessLink4gEnum.LINKSTATE]: FourGLinkStateEnum, // 4G 链路连接状态 {"0":"断开","1":"连接"}
    [WirelessLink4gEnum.QUALITY]: number, // 4G信号质量 0-5{"max":"5","min":"0","step":"1"}
    [WirelessLink4gEnum.UAVQUALITY]: number, // 天端飞行器端与 4G 服务器之间的信号质量 {"max":"5","min":"0","step":"1"}

  }
}

export interface OsdCameraLiveview {
  bottom: number,
  left: number,
  right: number,
  top: number,
}

export interface OsdCameraIrMeteringArea {
  x: number,
  y: number,
  width: number,
  height: number,
  aver_temperature: number,
  min_temperature_point: {
    x: number,
    y: number,
    temperature: number,
  },
  max_temperature_point: {
    x: number,
    y: number,
    temperature: number,
  }
}

export interface OsdCameraIrMeteringPoint {
  x: number,
  y: number,
  temperature: number,
}

// 飞行器相机信息
export interface DeviceOsdCamera {
  camera_mode: CameraMode, // 相机模式
  payload_index: string,
  photo_state: number, // 拍照状态 {"0":"空闲","1":"拍照中"}
  record_time: number, // 视频录制时长
  recording_state: number, // 录像状态 {"0":"空闲","1":"录像中"}
  remain_photo_num: number, // 剩余拍照张数
  remain_record_duration: number, // 剩余录像时间
  liveview_world_region: OsdCameraLiveview,
  screen_split_enable?: boolean, // 分屏是否使能 {"0":"分屏使能关闭","1":"分屏使能开启"}
  zoom_factor?: number, // 变焦倍数
  ir_zoom_factor?: number, // 红外变焦倍数
  ir_metering_mode?: number, // 红外测温模式 {"0":"关闭测温","1":"点测温","2":"区域测温"}
  ir_metering_point?: OsdCameraIrMeteringPoint, // 红外测温点
  ir_metering_area?: OsdCameraIrMeteringArea, // 红外测温区域
}

// 负载编号
export interface TypeSubtypeGimbalOsd {
  gimbal_pitch: number, // 云台俯仰轴角度 {"max":"180","min":"-180","step":0.1,"unit_name":"度 / °"}
  gimbal_roll: number, // 云台横滚轴角度 {"max":"180","min":"-180","step":0.1,"unit_name":"度 / °"}
  gimbal_yaw: number, // 云台偏航轴角度 {"max":"180","min":"-180","step":0.1,"unit_name":"度 / °"}
  measure_target_longitude: number, // 激光测距目标经度 {"max":"180","min":"-180","unit_name":"度 / °"}
  measure_target_latitude: number, // 激光测距目标纬度 {"max":"90","min":"-90","unit_name":"度 / °"}
  measure_target_altitude: number, // 激光测距目标海拔 {"unit_name":"米 / m"}
  measure_target_distance: number, // 激光测距距离 {"unit_name":"米 / m"}
  measure_target_error_state: number, //  激光测距状态 {"0":"NORMAL","1":"TOO_CLOSE","2":"TOO_FAR","3":"NO_SIGNAL"}
  payload_index: string, // 负载索引
  zoom_factor?: number, // 变焦倍数
  thermal_current_palette_style: number, // 调色盘样式 {"0":"白热","1":"黑热","2":"描红","3":"医疗","5":"彩虹 1","6":"铁红","8":"北极","11":"熔岩","12":"热铁","13":"彩虹 2"}
  thermal_supported_palette_styles: string[], // 设备支持的调色盘样式集合 {"size": -, "item_type": enum_int}
  thermal_gain_mode: number, // 增益模式 {"0":"自动","1":"低增益, 测温范围0°C-500°C","2":"高增益, 测温范围-20°C-150°C"}
  thermal_isotherm_state: number, // 是否开启等温线 {"0":"关闭","1":"开启"}
  thermal_isotherm_upper_limit: number, // 测温区间上限 {"unit_name":"摄氏度 / °C"}
  thermal_isotherm_lower_limit: number, // 测温区间下限 {"unit_name":"摄氏度 / °C"}
  thermal_global_temperature_min: number, // 全局画面中测量的最低温度 {"unit_name":"摄氏度 / °C"}
  thermal_global_temperature_max: number, // 全局画面中测量的最高温度 {"unit_name":"摄氏度 / °C"}
}

export enum AircraftStateEnum {
  // 待机
  STANDBY = 0,
  // 起飞准备
  TAKEOFF_PREPARATION = 1,
  // 起飞准备完毕
  TAKEOFF_READY = 2,
  // 手动飞行
  MANUAL_FLIGHT = 3,
  // 自动起飞
  AUTO_TAKEOFF = 4,
  // 航线飞行
  ROUTE_FLIGHT = 5,
  // 全景拍照
  PANORAMA_PHOTOGRAPHY = 6,
  // 智能跟随
  SMART_FOLLOW = 7,
  // ADS-B 躲避
  ADSB_AVOIDANCE = 8,
  // 自动返航
  AUTO_RETURN = 9,
  // 自动降落
  AUTO_LANDING = 10,
  // 强制降落
  FORCED_LANDING = 11,
  // 三桨叶降落
  THREE_BLADE_LANDING = 12,
  // 升级中
  UPDATING = 13,
  // 未连接
  DISCONNECTED = 14,
  // APAS
  APAS = 15,
  // 虚拟摇杆状态
  VIRTUAL_JOYSTICK = 16,
  // 指令飞行
  COMMAND_FLIGHT = 17,
  // 空中 RTK 收敛模式
  AIR_RTK_CONVERGENCE = 18,
  // 机场选址中
  AIRPORT_SITING = 19,

  POI = 20
}

// 飞行器OSD 信息
export interface DeviceOsd {
  longitude: number,
  latitude: number,
  gear: number, // 档位{"0":"A","1":"P","2":"NAV","3":"FPV","4":"FARM","5":"S","6":"F","7":"M","8":"G","9":"T"}
  mode_code: number, // 飞行器状态{"0":"待机","1":"起飞准备","2":"起飞准备完毕","3":"手动飞行","4":"自动起飞","5":"航线飞行","6":"全景拍照","7":"智能跟随","8":"ADS-B 躲避","9":"自动返航","10":"自动降落","11":"强制降落","12":"三桨叶降落","13":"升级中","14":"未连接","15":"APAS","16":"虚拟摇杆状态","17":"指令飞行","18":"空中 RTK 收敛模式","19":"机场选址中","20":"POI环绕","21":"进离场航线飞行过程中"}
  height: string,
  home_distance: string, // 距离 Home 点的距离
  horizontal_speed: string, // 水平速度
  vertical_speed: string, // 垂直速度
  wind_speed: string, // 风速
  wind_direction: string, // 当前风向{"1":"正北","2":"东北","3":"东","4":"东南","5":"南","6":"西南","7":"西","8":"西北"}
  elevation: string, // 相对起飞点高度
  position_state: { // 搜星状态
    gps_number: string, // GPS 搜星数量
    is_fixed: number, // 是否收敛 {"0":"未开始","1":"收敛中","2":"收敛成功","3":"收敛失败"}
    rtk_number: string // RTK 搜星数量
    quality: number, // 搜星档位{"1":"1档","2":"2档","3":"3档","4":"4档","5":"5档","10":"RTK fixed"}
  },
  battery: { // 飞行器电池信息
    capacity_percent: string, // 电池的总剩余电量
    landing_power: string, // 强制降落电量百分比
    remain_flight_time: number, // 剩余飞行时间
    return_home_power: string, // 返航所需电量百分比
    batteries: { // 电池详细信息
      capacity_percent: number, // 电池剩余电量
      firmware_version: string, // 固件版本
      high_voltage_storage_days: number,
      index: number, // 电池序号
      loop_times: number, // 电池循环次数
      sn: string, // 电池序列号（SN）
      sub_type: number, // 电池子类型
      temperature: number, // 温度
      type: number, // 电池类型{"1":"锂聚合物","2":"锂铁磷酸盐"}
      voltage: number, // 电压
    }[]
  },
  night_lights_state?: NightLightsStateEnum;// 夜航灯开关
  height_limit?: number;// 限高设置
  distance_limit_status?: DistanceLimitStatus;// 限远开关
  obstacle_avoidance?: ObstacleAvoidance;// 飞行器避障开关设置
  cameras?: DeviceOsdCamera[], // 飞行器相机信息
  total_flight_distance: number, // 飞行器累计飞行总里程
  total_flight_sorties: number, // 飞行器累计飞行总架次
  total_flight_time: number, // 飞行器累计飞行航时
  type_subtype_gimbalindex: TypeSubtypeGimbalOsd[], // 负载编号
  camera_watermark_settings: { // 相机水印设置
    global_enable: number, // 水印显示全局开关 {"0":"关闭","1":"开启"}
    layout: number, // 水印在画面中位置 {"0":"左上","1":"左下","2":"右上","3":"右下"}
  },
}

// 喊话器信息
export interface PsdkOsd {
  psdk_index: string, // psdk 负载设备索引
  psdk_type: string, // psdk类型 "4":"三方","5":"大疆自研"
  psdk_name: string, // 名称 "Searchlight":"探照灯","Speaker":"喊话器"
  psdk_sn: string, // SN
  psdk_version: string, // 版本
  psdk_lib_version: string, // lib版本
  speaker: { // 喊话器
    work_mode: string, // 工作模式 "0": "TTS模式", "1":"实时喊话","4": "边传边播", "5":"航线喊话"
    play_mode: string, // 播放模式 "0":"单曲播放","1":"循环播放"
    system_state: string, // 喊话器状态 "0":"空闲中","1":"传输中(机场到飞行器)","2":"播放中","3":"异常中","4":"TTS 文本转换中","99":"下载中(机场从云端下载)"
    play_volume: string, // 音量 "max":"100","min":"1"
    play_file_name: string, // 文件名称
    play_file_md5: string, // 文件验证
    tts_volume: string, // TTS播放音量 "max":"100","min":"1"
    tts_type: string, // TTS播放类型 "0":"男声","1":"女声"
    tts_language: string, // 语言 "0":"中文","1":"英文"
    tts_speed: string, // 语速 "max":"100","min":"1"
  },
  light: { // 探照灯
    work_mode: string, // 工作模式
    brightness: string, // 亮度
    calibration_status: string, // 校准 "0":"校准完成","1":"正在校准","2":"校准失败"
    calibration_progress: string, // 校准进度
    left_value: string, // 左灯微调值 "max":"+3°","min":-3"
    right_value: string, // 右灯微调值 "max":"+3°","min":-3"
    wide_field_mode: string, // 探照灯广视野模式是否开启 "false":"关闭","true":"开启"
    light_gimbal_control: string, // 探照灯云台联动是否开启 "false":"关闭","true":"开启"
    values: { // 自定义值空间位置
      index: string, // index
      value: string, // value
    }
  }
}

// 网络类型 {"1":"4G","2":"以太网"}
export enum NetworkStateTypeEnum {
  FOUR_G = 1,
  ETHERNET = 2,
}

// 网络状态质量枚举值 {"0":"无信号","1":"差","2":"较差","3":"一般","4":"较好","5":"好"}
export enum NetworkStateQualityEnum {
  NO_SIGNAL = 0,
  BAD = 1,
  POOR = 2,
  FAIR = 3,
  GOOD = 4,
  EXCELLENT = 5,
}

// {"0":"无雨","1":"小雨","2":"中雨","3":"大雨"}
export enum RainfallEnum {
  NONE = 0,
  LIGHT_RAIN = 1,
  MODERATE_RAIN = 2,
  HEAVY_RAIN = 3,
}

export const RainfallStatus = {
  [RainfallEnum.NONE]: '无雨',
  [RainfallEnum.LIGHT_RAIN]: '小雨',
  [RainfallEnum.MODERATE_RAIN]: '中雨',
  [RainfallEnum.HEAVY_RAIN]: '大雨',
}

// "1":"正北","2":"东北","3":"东","4":"东南","5":"南","6":"西南","7":"西","8":"西北"
export enum WindDirectionEnum {
  NORTH = 1,
  NORTHEAST = 2,
  EAST = 3,
  SOUTHEAST = 4,
  SOUTH = 5,
  SOUTHWEST = 6,
  WEST = 7,
  NORTHWEST = 8
}

export const WindDirectionStatus = {
  [WindDirectionEnum.NORTH]: '北风',
  [WindDirectionEnum.NORTHEAST]: '东北风',
  [WindDirectionEnum.EAST]: '东风',
  [WindDirectionEnum.SOUTHEAST]: '东南风',
  [WindDirectionEnum.SOUTH]: '南风',
  [WindDirectionEnum.SOUTHWEST]: '西南风',
  [WindDirectionEnum.WEST]: '西风',
  [WindDirectionEnum.NORTHWEST]: '西北风',
}

export enum DroneInDockEnum {
  OUTSIDE, INSIDE
}

export enum AirConditionerStateEnum {
  // 空闲模式(无制冷、制热、除湿等)
  IDLE = 0,
  // 制冷模式
  COOLING = 1,
  // 制热模式
  HEATING = 2,
  // 除湿模式
  DEHUMIDIFYING = 3,
  // 制冷退出模式
  COOLING_EXIT = 4,
  // 制热退出模式
  HEATING_EXIT = 5,
  // 除湿退出模式
  DEHUMIDIFYING_EXIT = 6,
  // 制冷准备模式
  COOLING_READY = 7,
  // 制热准备模式
  HEATING_READY = 8,
  // 除湿准备模式
  DEHUMIDIFYING_READY = 9,
  // 风冷准备中
  AIR_COOLING_READY = 10,
  // 风冷中
  AIR_COOLING = 11,
  // 风冷退出中
  AIR_COOLING_EXIT = 12,
  // 除雾准备中
  DEFROSTING_READY = 13,
  // 除雾中
  DEFROSTING = 14,
  // 除雾退出中
  DEFROSTING_EXIT = 15
}

export enum AirportStateEnum {
  // 空闲中
  IDLE = 0,
  // 现场调试
  ON_SITE_DEBUGGING = 1,
  // 远程调试
  REMOTE_DEBUGGING = 2,
  // 固件升级中
  FIRMWARE_UPDATING = 3,
  // 作业中
  OPERATING = 4,
  // 待标定
  PENDING_CALIBRATION = 5
}

export enum HatchStateEnum {
  // 关闭
  CLOSED = 0,
  // 打开
  OPEN = 1,
  // 半开
  HALF_OPEN = 2,
  // 舱盖状态异常
  ABNORMAL = 3
}

export enum AirportTaskStateEnum {
  // 作业准备中
  TASK_PREPARING = 0,
  // 飞行作业中
  FLIGHT_OPERATING = 1,
  // 作业后状态恢复
  POST_TASK_RECOVERY = 2,
  // 自定义飞行区更新中
  CUSTOM_FLIGHT_ZONE_UPDATING = 3,
  // 地形障碍物更新中
  TERRAIN_OBSTACLE_UPDATING = 4,
  // 任务空闲
  TASK_IDLE = 5,
  // 飞行器异常
  AIRCRAFT_ABNORMAL = 255,
  // 未知状态
  UNKNOWN_STATE = 256
}

export enum LiveStreamQualityEnum {
  // 自适应
  ADAPTIVE = 0,
  // 流畅
  SMOOTH = 1,
  // 标清
  STANDARD_DEFINITION = 2,
  // 高清
  HIGH_DEFINITION = 3,
  // 超清
  ULTRA_HIGH_DEFINITION = 4
}

export interface DockBasicOsd {
  network_state?: {
    type: NetworkStateTypeEnum,
    quality: number,
    rate: number,
  },
  drone_charge_state?: { // 飞行器充电状态
    state: number, // {"0":"空闲","1":"充电中"}
    capacity_percent: number,
  },
  drone_in_dock: boolean, // 飞行器是否在舱 {"0":"舱外","1":"舱内"}
  rainfall: RainfallEnum, // 降雨量
  wind_speed: number, // 风速
  environment_temperature: number, // 环境温度
  temperature: number, // 舱内温度
  humidity: number, // 舱内湿度
  latitude: number,
  longitude: number,
  height: number,
  alternate_land_point?: { // 备降点
    latitude: number,
    longitude: number,
    height: number,
    safe_land_height: number,
    is_configured: number // 是否设置备降点
  },
  first_power_on: number, // 首次上电时间
  position_state?: { // 搜星状态
    gps_number: number,
    is_fixed: number,
    rtk_number: number,
    is_calibration: number,
    quality: number,
  },
  storage?: { // 存储容量
    total: number, // 总容量
    used: number, // 已使用容量
  },
  mode_code: number, // 机场状态{"0":"空闲中","1":"现场调试","2":"远程调试","3":"固件升级中","4":"作业中","5":"待标定"}
  cover_state: HatchStateEnum, // 舱盖状态{"0":"关闭","1":"打开","2":"半开","3":"舱盖状态异常"}
  cover_force_close: HatchStateEnum, // 舱盖状态{"0":"关闭","1":"打开","2":"半开","3":"舱盖状态异常"}
  supplement_light_state: number, // 补充照明灯状态{"0":"关闭","1":"打开"}
  emergency_stop_state: number, // 紧急停止按钮状态{"0":"关闭","1":"打开"}
  air_conditioner?: { // 空调状态
    air_conditioner_state: AirConditionerStateEnum,
    switch_time: number,
  },
  air_transfer_enable?: boolean, // 空中回传{"0":"关闭","1":"打开"}
  battery_store_mode?: BatteryStoreModeEnum, // 电池保养(存储)模式
  alarm_state?: AlarmModeEnum, // 机场声光报警状态
  putter_state: number,
  sub_device?: { // 子设备状态
    device_sn?: string,
    device_model_key?: string,
    device_online_status: number, // 机场停机坪上的飞行器开机状态{"0":"关机","1":"开机"}
    device_paired: number, // 机场停机坪上的飞行器是否与机场对频{"0":"未对频","1":"已对频"}
  },
  live_capacity?: { // 直播能力
    available_video_number: number, // 可选择推流的码流数量
    coexist_video_number_max: number, // 可同时推流的最大码流数量
  },
  live_status?: { // 直播状态
    video_id: string, // 直播码流标识符
    video_type: string, // 直播码流类型
    video_quality: LiveStreamQualityEnum, // 直播码流质量{"0":"自适应","1":"流畅","2":"标清","3":"高清","4":"超清"}
    status: number, // 直播状态{"0":"未开始","1":"正在进行中"}
    error_status: number, // 直播错误状态{"0":"无异常","1":"网络异常"}
  }[],
}

// DRC 链路的状态 {"0":"未连接","1":"连接中","2":"已连接"}
export enum DrcStateEnum {
  DISCONNECT = 0,
  CONNECTING = 1,
  CONNECTED = 2
}

export interface DockLinkOsd {
  drc_state: DrcStateEnum,
  flighttask_prepare_capacity: number,
  flighttask_step_code: AirportTaskStateEnum,
  media_file_detail?: {
    remain_upload: number
  },
  sdr?: {
    up_quality: string,
    down_quality: string,
    frequency_band: number,
  },
  wireless_link?: { // 图传链路<会包括4G和sdr信息
    [WirelessLink4gEnum.FREQBAND]: number, // 4G频段
    [WirelessLink4gEnum.GNDQUALITY]: number, // 地面端（如遥控器、DJI Dock等）与 4G 服务器之间的信号质量 {"max":"5","min":"0","step":"1"}
    [WirelessLink4gEnum.LINKSTATE]: FourGLinkStateEnum, // 4G 链路连接状态 {"0":"断开","1":"连接"}
    [WirelessLink4gEnum.QUALITY]: number, // 4G信号质量 0-5{"max":"5","min":"0","step":"1"}
    [WirelessLink4gEnum.UAVQUALITY]: number, // 天端飞行器端与 4G 服务器之间的信号质量 {"max":"5","min":"0","step":"1"}
    dongle_number: number, // 飞行器上 Dongle 数量
    link_workmode: LinkWorkModeEnum, // 图传链路模式{"0":"SDR 模式","1":"4G 融合模式"}
    sdr_freq_band: number, // sdr频段
    sdr_link_state: SdrLinkStateEnum, // sdr链路连接状态{"0":"断开","1":"连接"}
    sdr_quality: number, // sdr信号质量 0-5{"max":"5","min":"0","step":"1"}
  },
  dongle_infos?: {
    imei: string,
    dongle_type: number, // {"6":"旧 Dongle","10":"支持 eSIM 的新 Dongle"}
    eid: string,
    esim_activate_state: number, // eSIM 激活状态 {"0":"未知","1":"未激活","2":"已激活"}
    sim_card_state: number, // SIM 卡状态 {"0":"未插入","1":"已插入"}
    sim_slot: number, // SIM 卡槽使能状态 {"0":"未知","1":"实体 SIM 卡","2":"eSIM"}
    sim_info?: {
      telecom_operator: number, // {"0":"未知","1":"移动","2":"联通","3":"电信"}
      sim_type: number, // SIM 卡使能状态 {"0":"未知","1":"其他普通 SIM 卡","2":"三网卡"}
      iccid: string, // SIM 卡的唯一识别标志
    },
    esim_infos?: {
      telecom_operator: number, // {"0":"未知","1":"移动","2":"联通","3":"电信"}
      enabled: boolean, // eSIM 使能状态 {"false":"未使用","true":"使用中"}
    }[],
  }[],
}

export interface MaintainStatus {
  state: number, // 保养状态{"0":"无保养","1":"有保养"}
  last_maintain_type: number, // 上一次保养类型 {"0":"无保养","17":"机场常规保养","18":"机场深度保养"}
  last_maintain_time: number, // 上一次保养时间
  last_maintain_work_sorties: number, // 上一次保养时作业架次
}

export interface DockWorkOsd {
  job_number: number, // 机场累计作业次数
  acc_time: number, // 机场累计运行时长
  activation_time: number, // 机场激活时间(unix 时间戳)
  maintain_status?: { // 保养信息
    maintain_status_array: MaintainStatus[]
  }
  electric_supply_voltage: number,
  working_voltage: string, // 工作电压
  working_current: string, // 工作电流
  backup_battery?: {
    voltage: number,
    temperature: number,
    switch: number,
  }
  drone_battery_maintenance_info?: { // 飞行器电池保养信息
    maintenance_state: DroneBatteryStateEnum, // 保养状态
    maintenance_time_left: number, // 电池保养剩余时间(小时)
  }
}

export interface DockOsd {
  basic_osd: DockBasicOsd,
  link_osd: DockLinkOsd,
  work_osd: DockWorkOsd,
}

export enum EModeCode {
  Standby, // 待机
  Preparing, // 起飞准备
  Ready, // 起飞准备完毕
  Manual, // 手动飞行
  Automatic, // 自动起飞
  Waypoint, // 航线飞行
  Panoramic, // 全景拍照
  Active_Track, // 智能跟随
  ADS_B, // ADS-B 躲避
  Return_To_Home, // 自动返航
  Landing, // 自动降落
  Forced_Landing, // 强制降落
  Three_Blades_Landing, // 三桨叶降落
  Upgrading, // 升级中
  Disconnected, // 未连接
  APAS,
  Virtual_Stick, // 虚拟摇杆状态
  Command_Flight, // 指令飞行
  RTK_Convergence, // 空中 RTK 收敛模式
  Airport_Siting, // 机场选址中
  Poi, // POI环绕
}

export const EModeCodeMap = {
  [EModeCode.Standby]: '待机',
  [EModeCode.Preparing]: '起飞准备',
  [EModeCode.Ready]: '起飞准备完毕',
  [EModeCode.Manual]: '手动飞行',
  [EModeCode.Automatic]: '自动起飞',
  [EModeCode.Waypoint]: '航线飞行',
  [EModeCode.Panoramic]: '全景拍照',
  [EModeCode.Active_Track]: '智能跟随',
  [EModeCode.ADS_B]: 'ADS-B 躲避',
  [EModeCode.Return_To_Home]: '自动返航',
  [EModeCode.Landing]: '自动降落',
  [EModeCode.Forced_Landing]: '强制降落',
  [EModeCode.Three_Blades_Landing]: '三桨叶降落',
  [EModeCode.Upgrading]: '升级中',
  [EModeCode.Disconnected]: '未连接',
  [EModeCode.APAS]: 'APAS',
  [EModeCode.Virtual_Stick]: '虚拟摇杆状态',
  [EModeCode.Command_Flight]: '指令飞行',
  [EModeCode.RTK_Convergence]: '空中 RTK 收敛模式',
  [EModeCode.Airport_Siting]: '机场选址中',
  [EModeCode.Poi]: 'POI 环绕',
}

export const EModeCodeMaps = {
  [EModeCode.Standby]: '待机',
  [EModeCode.Preparing]: '起飞准备',
  [EModeCode.Ready]: '起飞准备完毕',
  [EModeCode.Manual]: '手动飞行',
  [EModeCode.Automatic]: '自动起飞',
  [EModeCode.Waypoint]: '航线飞行',
  [EModeCode.Panoramic]: '全景拍照',
  [EModeCode.Active_Track]: '智能跟随',
  [EModeCode.ADS_B]: 'ADS-B 躲避',
  [EModeCode.Return_To_Home]: '自动返航',
  [EModeCode.Landing]: '自动降落',
  [EModeCode.Forced_Landing]: '强制降落',
  [EModeCode.Three_Blades_Landing]: '三桨叶降落',
  [EModeCode.Upgrading]: '升级中',
  [EModeCode.Disconnected]: '离线',
  [EModeCode.APAS]: 'APAS',
  [EModeCode.Virtual_Stick]: '虚拟摇杆状态',
  [EModeCode.Command_Flight]: '指令飞行',
  [EModeCode.RTK_Convergence]: '空中 RTK 收敛模式',
  [EModeCode.Airport_Siting]: '机场选址中',
  [EModeCode.Poi]: 'POI 环绕',
}

export enum EGear {
  A,
  P,
  NAV,
  FPV,
  FARM,
  S,
  F,
  M,
  G,
  T
}

export enum EDockModeCode {
  Disconnected = -1, // 未连接
  Idle = 0, // 空闲状态
  Debugging = 1, // 现场调试
  Remote_Debugging = 2, // 远程调试
  Upgrading = 3, // 固件升级中
  Working = 4, // 作业中
  ToBeCalibrated = 5, // 待标定
}

export const EDockModeCodeMap = {
  [EDockModeCode.Disconnected]: '离线',
  [EDockModeCode.Idle]: '空闲',
  [EDockModeCode.Debugging]: '现场调试',
  [EDockModeCode.Remote_Debugging]: '远程调试',
  [EDockModeCode.Upgrading]: '固件升级中',
  [EDockModeCode.Working]: '作业中',
  [EDockModeCode.ToBeCalibrated]: '待标定',
}

export interface DeviceHms {
  hms_id: string,
  tid: string,
  bid: string,
  sn: string,
  level: number,
  module: number,
  key: string,
  // message_en: string,
  message_zh: string,
  create_time: string,
  update_time: string,
  domain: number
}

// TODO: 设备拓扑管理优化
// 设备osd信息
export interface DeviceInfoType {
  gateway: GatewayOsd, // 遥控器
  dock: DockOsd, // 机场
  device: DeviceOsd, // 飞行器
}
